<template lang="pug">
  keep-alive(
    :include="keepAliveModals",
  )
    component.TheModal(
      v-if="currentModal",
      :no-animation="replacing",
      v-bind="props",
      :is="currentModal",
      :value="isOpen",
      @cancel="onCancel",
      @error="onError",
      @success="onSuccess",
    )
</template>

<script>
const KEEP_ALIVE_EXCLUDED_LIST = ['ModalDocuSign'];

export default {
  name: 'TheModal',
  data() {
    return {
      currentModal: null,
      replacing: false,
      isOpen: false,
      keepAliveList: [],
      props: {},
      options: {},
    };
  },
  computed: {
    keepAliveModals() {
      return this.keepAliveList.filter(item => !KEEP_ALIVE_EXCLUDED_LIST.includes(item));
    },
  },
  watch: {
    // close modal on route change
    '$route.name': 'closeModal',
    currentModal: {
      handler(newModal, oldModal) {
        this.replacingModalHandler(newModal, oldModal);
      },
      immediate: true,
    },
  },
  methods: {
    // this method using as interface for openModal script
    setCurrentModal(modalComponent, props, options) {
      this.currentModal = modalComponent;
      this.props = props;
      this.options = options;
      this.isOpen = true;
      this.keepAliveList = this.keepAliveList.concat(modalComponent.name);
    },
    closeModal() {
      this.isOpen = false;
      const { currentModal } = this;
      setTimeout(() => {
        // Check if modal is not checked during timeout. If yes, do nothing
        if (currentModal !== this.currentModal) return;
        this.options = {};
        this.props = {};
        this.currentModal = null;
        this.keepAliveList = [];
      }, 300);
    },
    /**
     * This function is used to skip animation when modal changing from one to another
     * @param newModal - new current modal
     * @param oldModal - previous modal
     */
    replacingModalHandler(newModal, oldModal) {
      // set replacing flag to do not show animation
      this.replacing = Boolean(newModal && oldModal);
      if (this.keepAliveList.length <= 1) {
        setTimeout(() => {
          // after animation, remove flag to back animation
          this.replacing = false;
        }, 1000);
      }
    },
    onCancel() {
      this.closeModal();
      this.options?.onCancel();
    },
    onError(error) {
      this.options?.onError(error);
    },
    onSuccess(result) {
      this.options?.onSuccess(result);
    },
  },
};
</script>
